// extracted by mini-css-extract-plugin
module.exports = {"group":"UDJQW","group-info":"+TKJx","groups":"roOyv","group-description":"q3MSD","group-title":"l4XG-","group-items":"aLwXD","grid":"_6nJ+V"};